import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormConsultationComponent } from './form-consultation/form-consultation.component';
import { PrescriptionHubComponent } from '@shared/components/prescription-hub/prescription-hub.component';

@Component({
  selector: 'app-main-consultation',
  standalone: true,
  imports: [CommonModule, FormConsultationComponent, PrescriptionHubComponent],
  templateUrl: './main-consultation.component.html',
  styleUrl: './main-consultation.component.scss'
})
export class MainConsultationComponent {
  showHubModal = false;
  savedConsultation: any = {};
  hubBeneficiaire: any = {};

  onGoToTab(data: any) {
    if (data?.tab === 'prescriptions') {
      this.savedConsultation = data.consultation ?? {};
      this.hubBeneficiaire = data.beneficiaire ?? {};
      this.showHubModal = true;
    }
  }

  closeHubModal() {
    this.showHubModal = false;
  }
}
